import styled from '@emotion/styled'
import { PRIMARY_FONT_CSS_VAR } from '../../../context/CustomizationContextProvider'

export const BottomControlsOuterContainer = styled.div({
    width: '100%',
    background:
        'linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.6) 30%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.2) 70%, rgba(0, 0, 0, 0.1) 85%, rgba(0, 0, 0, 0) 100%)',
    borderBottomLeftRadius: 'inherit',
    borderBottomRightRadius: 'inherit',
    paddingBottom: 'max(16px, env(safe-area-inset-bottom))',
    marginTop: 'auto',
})

export const BottomControlsContainer = styled.div(() => ({
    fontFamily: `var(${PRIMARY_FONT_CSS_VAR}, Helvetica)`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    minHeight: 0,
    width: '100%',
    borderRadius: '0px',
}))

export const LPBottomControlsDiv = styled.div({
    width: '100%',
    paddingRight: 16,
    paddingLeft: 16,
    height: 'auto',
    bottom: 0,
    textAlign: 'center',
    paddingBottom: 14,
    display: 'flex',
    flexDirection: 'row',
    zIndex: 3,
})
